import * as ActionType from '../actiontypes/ActionType';

const intialState = {

}
const caseDetailsReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case ActionType.CASEDETAILS:
            return {
                ...state,
                caseSearchVo: payload
            }
        default:
            return state;
    }
};

export default caseDetailsReducer;